<template>
    <v-dialog v-model="dialog" max-width="600" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Reminder sent to {{ reminder.employee.firstName }} {{ reminder.employee.lastName }}</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text class="text-xs-left">
                <div v-if="reminder.unacknowledgedPD">
                    <v-subheader class="px-0">Unacknowledged {{ $term('positionDescription') }}:</v-subheader>
                    <ul>
                        <li>
                            {{ reminder.unacknowledgedPD.positionTitle }}
                        </li>
                    </ul>
                </div>
				 <div v-if="reminder.unacknowledgedHrDocuments.length > 0">
                    <v-subheader class="px-0">Unacknowledged policies:</v-subheader>
                     <ul>
                        <li v-for="(policy, index) in reminder.unacknowledgedHrDocuments" :key="index">
                            {{ policy.name }}
                        </li>
                    </ul>
                </div>

			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<v-btn flat @click="onClose">Close</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
            reminder: {
                type: Object,
                required: true
            }
		},
		methods: {
			onClose() {
				this.$emit('onClose');
			}
		}
	};
</script>
